import { render, staticRenderFns } from "./comp-button.vue?vue&type=template&id=f00b5906"
import script from "./comp-button.vue?vue&type=script&lang=js"
export * from "./comp-button.vue?vue&type=script&lang=js"
import style0 from "./comp-button.vue?vue&type=style&index=0&id=f00b5906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports